import React, { Component, Fragment  } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Icon, Menu } from 'semantic-ui-react';
import {exportSales} from '../actions';

class SalesReportMenu extends Component {
    state = {
        selectedSubMenu: 'totalsales',
        activeItem: ''
        
    }

    handleExportClick = (e) => this.props.exportSales(true);

    render() {
        const { activeItem } = this.state;
        const { selectedSubMenu } = this.state;

        return (
            <Fragment>
                
                <Menu fixed='left' vertical style={{ marginTop: '5em', marginLeft: '0em' }}>
                    <Menu.Item key='totalsales' name="totalsales" active={selectedSubMenu === 'totalsales'}>
                        Total Sales
                    </Menu.Item>

                    {/* <Menu.Item name='messages' active={activeItem === 'messages'} onClick={this.handleExportClick.bind(this)}>
                    <Icon name='download' />
                    Export
                </Menu.Item> */}

                </Menu>

               
            </Fragment>
        )
    }
}
const mapStateToProps = ({ sales }) => {
    return { sales }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        exportSales: exportSales
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(SalesReportMenu);